import React, { useEffect, useState } from 'react'
import Dropdown from "../Dropdown/Dropdown"
import { getUtilValues } from "./helper"
import { LuTrash2 } from "react-icons/lu"

const isDropdownType = (type, utils) => {
  const typeUtils = utils?.filter(u => u.type === type)
  return typeUtils?.length > 0 && typeUtils.every(u => !u.isValueNeeded)
}

const FiltersInputLine = ({
                            filters,
                            utils,
                            deleteItem,
                            index,
                            handleRequestFilterChange,
                            filterLine,
                          }) => {
  const [isOpenFilters, setIsOpenFilters] = useState(false)
  const [isOpenUtils, setIsOpenUtils] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState({})
  const [selectedUtil, setSelectedUtil] = useState({})
  const [selectedElements, setSelectedElements] = useState([])
  const [filteredMenuItems, setFilteredMenuItems] = useState([])

  const [selectedValue, setSelectedValue] = useState('')
  const [isFilterFocused, setIsFilterFocused] = useState(false)
  const [isUtilFocused, setIsUtilFocused] = useState(false)
  const [isMultipleChoice, setIsMultipleChoice] = useState(false)

  const handleChange = (event) => {
    const filter = filters?.find((item) => item.value === event)
    setSelectedFilter(filter)
    handleRequestFilterChange(index, { fieldName: filter?.value, filterType: filter?.type })
  }

  const handleChangeUtil = (event) => {
    if (isMultipleChoice) {
      const selected = filteredMenuItems.filter((item) => event.includes(item.value))

      setSelectedElements(selected)

      handleRequestFilterChange(index, {
        fieldName: selectedFilter?.value,
        filterType: selectedFilter?.type,
        operator: selected.map((el) => el.value),
      })
    } else {
      const util = filteredMenuItems.find((item) => item.value === event)
      setSelectedUtil(util)
      handleRequestFilterChange(index, {
        fieldName: selectedFilter?.value,
        filterType: selectedFilter?.type,
        operator: util?.value
      })
    }
  }

  const handleChangeValue = (value) => {
    setSelectedValue(value)
    handleRequestFilterChange(index, {
      fieldName: selectedFilter?.value,
      filterType: selectedFilter?.type,
      operator: selectedUtil?.value,
      value
    })
  }

  const isFirstEl = index === 0

  const getMenuItemsByType = async ({ type }) => {
    const defaultUtils = utils?.filter(el => el.type === type)

    setFilteredMenuItems(defaultUtils)
    setIsMultipleChoice(isDropdownType(type, utils))
  }

  useEffect(() => {
    if (isDropdownType(filterLine?.filterType, utils) || Array.isArray(filterLine?.operator)) {
      setIsMultipleChoice(true)
    } else {
      setIsMultipleChoice(false)
    }

    if (filterLine?.fieldName) {
      const filter = filters?.find((item) => item.value === filterLine?.fieldName)
      setSelectedFilter(filter)
    } else {
      setSelectedFilter({})
      setSelectedUtil({})
      setSelectedElements([])
      setFilteredMenuItems([])
    }

    if (filterLine?.value) {
      setSelectedValue(filterLine?.value)
    } else {
      setSelectedValue('')
    }
  }, [filterLine, filters])

  useEffect(() => {
    if (filterLine?.operator && isMultipleChoice) {
      if (Array.isArray(filterLine.operator)) {
        const selected = utils?.filter(item => filterLine.operator.includes(item.value))
        setSelectedElements(selected)
      }
    }
  }, [utils, filterLine?.operator, isMultipleChoice])

  useEffect(() => {
    if (selectedFilter?.type) {
      getMenuItemsByType({ type: selectedFilter?.type })
    }
  }, [selectedFilter])

  useEffect(() => {
    if (!filteredMenuItems) return

    if (isMultipleChoice && Array.isArray(filterLine?.operator)) {
      const selected = filteredMenuItems.filter(item =>
        filterLine.operator.includes(item.value)
      )
      setSelectedElements(selected)
    } else if (filterLine?.operator) {
      const util = filteredMenuItems.find(item => item.value === filterLine.operator)
      setSelectedUtil(util)
    }
  }, [filteredMenuItems, isMultipleChoice, filterLine?.operator])


  return (
    <div className={`w-full flex items-center justify-center mb-6 gap-4`}>
      <p className={`${isFirstEl ? 'mr-4' : 'mr-8'}`}>{`${isFirstEl ? 'Where' : 'And'}:`}</p>
      <Dropdown className="w-full min-w-[235px]" isOpen={isOpenFilters}
                isFocused={isFilterFocused} setIsOpen={setIsOpenFilters} setIsFocused={setIsFilterFocused}
                menuItems={filters} placeholder="Select a filter" setValue={handleChange}
                value={selectedFilter?.value}/>
      {
        filterLine?.fieldName && <div>
          <Dropdown className="w-[235px]" isOpen={isOpenUtils}
                    isFocused={isUtilFocused} setIsOpen={setIsOpenUtils}
                    setIsFocused={setIsUtilFocused}
                    menuItems={filteredMenuItems}
                    placeholder="Select an operation"
                    setValue={handleChangeUtil}
                    isMulti={isMultipleChoice}
                    value={
                      isMultipleChoice
                        ? selectedElements.map(el => el.value)
                        : selectedUtil?.value
                    }/>
        </div>
      }
      {
        filterLine?.operator && selectedUtil?.isValueNeeded && getUtilValues({
          selectedUtil,
          handleChangeValue,
          selectedValue
        })
      }
      <button className="ml-4" onClick={deleteItem}>
        <LuTrash2 size={18} className="text-text-secondary" />
      </button>
    </div>
  )
}

export default FiltersInputLine